/*

 +-++-++-++-++-++-++-++-++-++-++-++-++-+
 |Q||u||a||r||t||e||r||M||a||s||t||e||r|
 +-++-++-++-++-++-++-++-++-++-++-++-++-+

 Interceptor for rewards

 */

import * as Sentry from '@sentry/browser';

import { store } from '../redux';

import { showNetworkAlert } from '../redux/auth/actions';
import constants from '../constants';

export const errorHandler = response => {
  // console.error('API ERROR -', response);
  let errorData = response.data || response;

  switch (response.problem) {
    case 'TIMEOUT_ERROR':
    case 'CONNECTION_ERROR':
    case 'NETWORK_ERROR':
      store.dispatch(
        showNetworkAlert({
          showNetworkError: true,
          networkErrorMessage:
            'It appears there was an issue with your network. Please try again',
        }),
      );
      break;
    default:
      break;
  }
  Sentry.captureException(JSON.stringify(errorData, null, 2));
};
export const errorInterceptor = response => {
  if (
    response.status === 503 &&
    response.data &&
    response.data.message === 'Service Unavailable'
  ) {
    window.location.href = `${constants.BASE_URL}/maintenance`;
    return response;
  }
  if (
    !response.ok ||
    response.status > 299 ||
    response.problem ||
    !(response.data.status < 300 && response.data.status >= 200)
  ) {
    errorHandler(response);
  }
};
